import React, {useEffect, useState} from "react";
import {Title} from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import {Button} from "../../../../stories/Button/Button";
import {
  getFileIcon,
  toInputStandardDate,
} from "../../../../utils/UtilFunctions";
import {useLazyQuery} from "@apollo/client";
import {CaseStudyNode} from "./queries/types";
import {nodeVar} from "../../../../utils/commonQueryTypes";
import {getCaseStudyByNodeId} from "./queries/query";
import {FormData} from "./Add";
import {IObjectKeys} from "../../../../utils/formTypes";
import {getDownloadUrl} from "../../../../utils/DownloadFile";
import useUrlParams from "../../../../customHooks/useUrlParams";
interface props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  caseStudyID: number;
}

interface modifiedFormData extends FormData, IObjectKeys {
  synopsis: string;
}

const ViewCaseStudyDetails = ({setModal, caseStudyID}: props) => {
  const {customer_id} = useUrlParams();

  const [GetCaseStudy, {data}] = useLazyQuery<{node: CaseStudyNode}, nodeVar>(
    getCaseStudyByNodeId
  );

  const [attachments, setAttachments] = useState<string[]>([]);

  const [formData, setFormData] = useState<modifiedFormData>({
    title: "",
    startDate: "",
    endDate: "",
    synopsis: "",
    caseType:""
  });

  useEffect(() => {
    if (caseStudyID) {
      GetCaseStudy({
        variables: {
          id: caseStudyID,
        },
      }).then(({data}) => {
        if (data && data.node) {
          setFormData({
            endDate: toInputStandardDate(data.node.endDate),
            startDate: toInputStandardDate(data.node.startDate),
            title: data.node.title,
            synopsis: data.node.synopsis,
            caseType:data.node.caseType
          });
          if (data.node.documents)
            setAttachments(data.node.documents.split(";"));
        }
      });
    }
  }, [caseStudyID, GetCaseStudy, data]);

  return (
    <div className="view-case-study">
      <div className="view-case-study__title">
        <Title>View Case Study</Title>
        <img
          src={Close}
          alt=""
          onClick={() => setModal(false)}
          className="modal-close-icon"
        />
      </div>
      <div className="view-case-study__block">
        <div className="view-case-study__block--left">
          <div className="view-case-study__block--left--header">
            <span>Title</span>
            <b title="project_name">{formData.title}</b>
            <span>Synopsis</span>
          </div>
          <div
            className="view-case-study__block--left--block"
            dangerouslySetInnerHTML={{__html: formData.synopsis}}
          ></div>
        </div>
        <div className="view-case-study__block--right">
          <Title variant="subtitle1">Attachments</Title>
          <div className="view-case-study__block--right--block">
            {attachments.length
              ? attachments.map((files, index) => {
                  const filename = files.split("/").pop();
                  const ext = filename?.split(".").pop();
                  const modifiedFileName = `${customer_id}/caseStudies/${caseStudyID}_${index}.${ext}`;
                  return (
                    <div
                      className="case-study-list--attachments"
                      key={index}
                      onClick={() => getDownloadUrl(modifiedFileName, true)}
                    >
                      <img src={getFileIcon(files)} alt="" />
                      <span> {filename}</span>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </div>
      <Button mode="cancel" onClick={() => setModal(false)} />
    </div>
  );
};

export default ViewCaseStudyDetails;
